<app-paged-table mode="base-2">
  <ng-container pre-table>
    <div class="d-flex align-items-center justify-content-space-between gap-16 m-b-16">
      <p class="p1">
        {{ 'History:' | trans:'cards/card/transactions/history.Label' }}
      </p>

      <div class="d-flex align-items-center gap-8">
        <p class="p1 c-t-blue-700 text-uppercase">
          {{ 'Balance' | trans:'cards/card/transactions/balance.Label' }}
        </p>
        <div class="tag c-bg-blue-200">
          {{ card?.currentBalance | numberToCurrency }} {{ languageConfig.currency.short }}
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container thead>
    <tr class="text-right">
      <th>
        {{ 'Type of transaction' | trans:'cards/card/transactions/transactionType.Label' }}
      </th>
      <th>
        {{ 'Date' | trans:'cards/card/transactions/date.Label' }}
      </th>
      <th>
        {{ 'Amount' | trans:'cards/card/transactions/amount.Label' }}
      </th>
      <th>
        {{ 'balance' | trans:'cards/card/transactions/cardAmount.Label' }}
      </th>
    </tr>
  </ng-container>

  <ng-container tbody>
    @for (t of data; track t.id) {
      <tr class="text-right">
        <td>
          <p class="t4 fw-medium c-t-blue-700 text-uppercase">
            {{ t.transactionType | trans:'cards/card/transactions/transactionType/type.' + t.transactionType }}
          </p>
        </td>
        <td>
          <p class="p1">
            {{ t.date | localeDatetimeFormat }}
          </p>
        </td>
        <td>
          <div class="tag {{ t.amount > 0 ? 'c-bg-ok-300' : 'c-bg-nok-200' }} to-right">
            {{ t.amount > 0 ? '+ ' : '- ' }}{{ (t.amount | mathAbs) | numberToCurrency }} {{ languageConfig.currency.short }}
          </div>
        </td>
        <td>
          {{ t.cardAmount | numberToCurrency }} {{ languageConfig.currency.short }}
        </td>
      </tr>
    }
  </ng-container>
</app-paged-table>
